/**
 * @author        woody@zumper.com (Woody Anderson)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   singleton browser history object
 */

import { createBrowserHistory } from 'history'

// createBrowserHistory may only be called in client code,
// but after that, having singleton access is useful

let gBrowserHistory: ReturnType<typeof createBrowserHistory<unknown>> | null = null

const getBrowserHistory = () => {
  gBrowserHistory = gBrowserHistory || createBrowserHistory<unknown>()
  return gBrowserHistory
}

export default getBrowserHistory
